// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"634ceb71","239":"bbedeac7","732":"b3f4b994"}[chunkId] + ".chunk.js";
};